export default __webpack_public_path__ + "static/cuadrado_la_exhibicion-daec53d6c2a321128a8be96b136707b4.png";